import { RENDERED_ART } from './renderedArt';

/**
 * The file holding the current render for a rendered-art address such as
 * '/hero/league-party.webm' (see renderedArt.ts). Layouts keep storing the
 * plain address, so a re-render needs no data change; any other URL passes
 * through untouched.
 */
export function artUrl(url: string): string {
  return RENDERED_ART[url] ?? url;
}

/** Is this path one of the hashed render files, whose content never changes? */
export function isRenderedArtFile(path: string): boolean {
  return RENDERED_FILES.has(path);
}

const RENDERED_FILES = new Set(Object.values(RENDERED_ART));
